module.exports = __webpack_public_path__ + "img/senalando-izq.png.e1da4af0.webp";